// Simple bilingual dictionary. UI strings only; English is the language of practice.
export const dict = {
  es: {
    brand: "ListoTalk AI",
    subbrand: "Práctica de inglés laboral",
    langToggle: "EN",
    langToggleAria: "Cambiar idioma entre español e inglés",
    signIn: "Iniciar sesión",
    signUp: "Crear cuenta",
    signOut: "Cerrar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    passwordHint: "Mínimo 8 caracteres.",
    or: "o",
    tryPractice: "Probar una práctica",
    tryFree: "Probar una práctica gratis",
    heroTitle: "Practica el inglés que usas cada día en el trabajo",
    heroSub: "Conversaciones cortas con retroalimentación clara en español. Solo escenarios ficticios.",
    valueRealScenarios: "Escenarios reales de servicio al cliente",
    valueVoice: "Voz y texto: elige cómo practicar",
    valueSpanishCoach: "Retroalimentación clara, sin presión",
    pilotBadge: "Piloto de investigación · No es un producto en venta",
    disclaimer: "Guía de práctica generada por IA. No es una evaluación certificada.",
    accountSection: "Tu cuenta",
    dashboardTitle: "Elige una práctica",
    dashboardSub: "Cinco situaciones cortas para practicar hoy.",
    continue: "Continuar",
    startPractice: "Empezar práctica",
    briefingTitle: "Antes de empezar",
    goal: "Objetivo",
    facts: "Datos ficticios de la conversación",
    checkpoints: "Objetivos de la tarea",
    phrases: "Frases útiles en inglés",
    startConvo: "Comenzar conversación",
    conversation: "Conversación",
    speakNormal: "Velocidad normal",
    speakSlow: "Más despacio",
    replay: "Repetir audio",
    hint: "Pedir ayuda",
    hintOff: "Cerrar ayuda",
    hintLoading: "Cargando ayuda…",
    hintCoachingLabel: "Pista",
    hintStarterCta: "Puedes empezar con…",
    hintExampleCta: "Ver ejemplo",
    hintFillDraftCta: "Usar como borrador",
    hintGuidedNote: "Este ejemplo cuenta como práctica guiada, no como evidencia independiente.",
    micTap: "Mantén pulsado o toca para hablar",
    stop: "Detener",
    listen: "Escuchar",
    submit: "Enviar",
    typeAnswer: "Escribir mi respuesta",
    switchToVoice: "Cambiar a voz",
    switchToText: "Cambiar a texto",
    finish: "Terminar y revisar mi práctica",
    processing: "Procesando…",
    recording: "Grabando…",
    transcribing: "Transcribiendo…",
    responding: "Cliente respondiendo…",
    reviewTranscript: "Revisa antes de enviar",
    micDenied: "Permiso del micrófono denegado. Puedes escribir tu respuesta.",
    micUnsupported: "Tu navegador no permite grabación aquí. Usa el modo texto.",
    aiUnavailable: "El servicio de IA no está disponible. Intenta más tarde.",
    dailyLimit: "Alcanzaste el límite diario de prácticas. Vuelve mañana.",
    guestNote: "Estás practicando como invitado. Crea una cuenta para guardar tu progreso.",
    feedbackTitle: "Retroalimentación",
    doneWell: "Cosas hechas muy bien",
    improvements: "Puntos para mejorar",
    modelResponse: "Respuesta modelo",
    checkpointsList: "Objetivos de la tarea",
    original: "Tu frase",
    improved: "Frase mejorada",
    explanation: "Explicación",
    retry: "Reintentar esta práctica",
    backHome: "Volver al inicio",
    progressTitle: "Mi progreso",
    noHistory: "Aún no tienes prácticas guardadas.",
    deletePractice: "Eliminar",
    confirmDelete: "¿Eliminar esta práctica?",
    deleteAccount: "Eliminar mi cuenta y todos mis datos",
    confirmDeleteAccount: "Esto borrará tu cuenta y todos tus datos. ¿Continuar?",
    onboardingTitle: "Un par de datos antes de empezar",
    onboardingLevel: "Tu nivel de inglés",
    onboardingContext: "¿En qué área trabajas? (opcional)",
    levelBasic: "Básico",
    levelBasicHint: "Frases sencillas y apoyo frecuente",
    levelInter: "Intermedio",
    levelInterHint: "Flujo continuo, con matices",
    saveContinue: "Guardar y continuar",
    skip: "Saltar",
    workContextCallCenter: "Call center",
    workContextHospitality: "Hotelería",
    workContextRestaurant: "Restaurante",
    workContextRetail: "Comercio",
    workContextTravel: "Viajes y aeropuerto",
    workContextOther: "Otro",
    pilotConsent:
      "Usa solo datos ficticios. No compartas información real de clientes o empleadores.",
    unsupportedNotice: "Grabación de voz no disponible en este dispositivo.",
    completed: "Completada",
    inProgress: "En progreso",
    date: "Fecha",
    scenario: "Escenario",
    close: "Cerrar",
    tabPractice: "Prácticas",
    tabProgress: "Mi progreso",
    guestBanner: "Modo invitado",
    saved: "Guardado",
    ttsUnavailable: "Audio no disponible en este momento.",
    finishConfirm: "¿Terminar la práctica y revisarla?",
    yes: "Sí",
    no: "No",
    errorGeneric: "Ocurrió un error. Intenta de nuevo.",
    authEmailTaken: "Este correo electrónico ya está registrado.",
    authInvalidCredentials: "Correo electrónico o contraseña incorrectos.",
    feedbackLoading: "Preparando tu revisión…",
    feedbackLoadErrorTitle: "No pudimos cargar tu revisión",
    feedbackLoadRetry: "Reintentar",
    modeVoice: "Voz",
    modeText: "Texto",
    aiCustomer: "Cliente (IA)",
    youEmployee: "Tú (empleado)",
    finishedBadge: "Práctica concluida",
    unsavedTitle: "¿Qué quieres hacer con esta práctica?",
    unsavedBody: "Aún no la guardaste en Mi progreso.",
    unsavedSaveCta: "Guardar en Mi progreso",
    unsavedReviewCta: "Revisar mi práctica",
    unsavedExitCta: "Salir sin guardar",
    invalidFeedback: "No pudimos generar retroalimentación estructurada. Prueba practicar nuevamente.",
    speakingTip: "Puedes hablar en inglés al cliente. Recuerda que es una práctica ficticia.",
    accountEmail: "Correo",
    createAccount: "Crear cuenta nueva",
    haveAccount: "¿Ya tienes cuenta? Inicia sesión",
    noAccount: "¿No tienes cuenta? Regístrate",
    formError: "Revisa los campos e intenta de nuevo.",
    finishConfirmYes: "Sí, terminar",
    retryThisReply: "Practicar esta respuesta de nuevo",
    retryPlaceholder: "Escribe tu nueva respuesta en inglés",
    retrySubmit: "Enviar retry",
    retryOriginal: "Respuesta original",
    retryNew: "Tu nueva respuesta",
    retryCustomerReply: "Nueva respuesta del cliente",
    coachNote: "Comentario del coach",
    saveToHistory: "Guardar en mi historial",
    saveOff: "Guardado. Toca para quitar del historial.",
    saveNotice:
      "Solo guardamos tus prácticas si tú lo eliges. Puedes borrarlas cuando quieras.",
    progressSummary: "Resumen",
    progressCompleted: "Objetivos logrados",
    progressInProgress: "En progreso",
    progressSaved: "Guardadas",
    recentPhrases: "Frases útiles recientes",
    checkpointsImproved: "Objetivos que mejoraste",
    notEnoughPractice: "Aún no hay suficiente práctica guardada para mostrar cambios.",
    retryLimit: "Alcanzaste el límite de retries en esta práctica.",
    retryHelp:
      "Reintentar solo esta respuesta. No cambia el resultado de la práctica.",
    // V1 additions
    tabHome: "Inicio",
    tabPhrases: "Mis Frases",
    tabSettings: "Ajustes",
    homeGreeting: "Hola",
    homeContinue: "Continuar tu práctica",
    homeRecommended: "Recomendado para ti",
    homeCreate: "Crear mi propia situación",
    homeCreateSub: "Describe una situación real de tu trabajo y crearemos una práctica.",
    homePlanNote: "Recomendaciones basadas en tu perfil y prácticas guardadas.",
    workProfile: "Mi trabajo",
    workProfileSub: "Ajusta esto en cualquier momento en Ajustes.",
    industry: "Sector o entorno",
    roleLabel: "Puesto o rol",
    tasks: "Tareas frecuentes",
    partners: "Con quién hablas",
    needsHeader: "Necesidades de comunicación",
    timePref: "Tiempo por sesión",
    languagePref: "Idioma preferido",
    levelAdvanced: "Avanzado",
    levelAdvancedHint: "Frases ricas y conversación real",
    partnerCustomer: "Clientes",
    partnerCoworker: "Compañeros",
    partnerSupervisor: "Supervisor",
    partnerPatient: "Pacientes/visitantes",
    needAskClar: "Pedir aclaración",
    needUnderstand: "Entender una petición",
    needExplain: "Explicar un problema",
    needAskPerm: "Pedir permiso con cortesía",
    needReportStatus: "Reportar avance",
    needAskHelp: "Pedir ayuda o insumos",
    needDisagree: "Manejar desacuerdo",
    needPhone: "Conversaciones telefónicas",
    needTalkSup: "Hablar con un supervisor",
    industryRetail: "Comercio / cajero",
    industryHospitalClean: "Limpieza / housekeeping",
    industryHospitality: "Hotelería",
    industryRestaurant: "Restaurante",
    industryCallCenter: "Call center",
    industryTravel: "Viajes / aeropuerto",
    industryOffice: "Oficina",
    industryOther: "Otro / Describir mi trabajo",
    createSituationTitle: "Crear mi propia situación",
    createSituationHint:
      "Describe brevemente qué pasa. Usa datos ficticios: nunca compartas nombres reales, expedientes, o información confidencial de tu empleador o clientes.",
    createSituationPlaceholder:
      "Ej: Limpio habitaciones y necesito pedir permiso al paciente para entrar.",
    generate: "Generar práctica",
    regenerate: "Volver a generar",
    startNow: "Empezar ahora",
    aiCreatedLabel: "Creada por IA — no es capacitación profesional aprobada",
    curatedLabel: "Contenido revisado",
    reportContent: "Reportar contenido",
    reportPlaceholder: "Describe el problema con esta práctica…",
    reportSubmit: "Enviar reporte",
    reportSent: "Reporte enviado. Gracias.",
    phrasesTitle: "Mis frases guardadas",
    phrasesEmpty: "Aún no tienes frases guardadas. Guárdalas desde la retroalimentación.",
    savePhraseCta: "Guardar esta frase",
    savedPhrase: "Frase guardada",
    reviewMode: "Modo de repaso",
    reviewCta: "Repasar",
    reviewPromptEs: "Frase en español",
    revealAnswer: "Ver respuesta en inglés",
    typeYourAnswer: "Escribe tu respuesta en inglés",
    submitReview: "Enviar",
    settingsTitle: "Ajustes",
    changePassword: "Cambiar contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    passwordChanged: "Contraseña cambiada.",
    exportMyData: "Exportar mis datos",
    exportedNote: "Se descargó un archivo JSON con tus datos.",
    helpTitle: "Ayuda",
    faqPractice: "Cómo practicar",
    faqAI: "Sobre la IA y la retroalimentación",
    faqPronunciation: "Pronunciación",
    faqPrivacy: "Privacidad y datos",
    faqAIText:
      "La retroalimentación se genera con IA y puede tener errores. No es una evaluación certificada de idioma.",
    faqPronText:
      "Este piloto NO evalúa acento ni pronunciación desde audio. Se enfoca en comunicación clara y tono profesional.",
    faqPrivacyText:
      "Solo guardamos las prácticas que decides guardar. El audio se procesa temporalmente y se elimina después de transcribir. Puedes exportar o borrar tus datos en Ajustes.",
    accessTitle: "Acceso al piloto",
    accessBody:
      "Este es un piloto de investigación. Precio propuesto: $15/mes, sin venta activa. No hay compra ni cobros.",
    accessRemaining: "Prácticas restantes hoy",
    accessCustomGenLeft: "Generaciones personalizadas restantes hoy",
    installHome: "Añadir a pantalla de inicio",
    installHint: "En tu teléfono usa el menú del navegador y selecciona 'Añadir a inicio' o 'Instalar'.",
    contentSource: "Fuente",
    contentCurated: "Revisado",
    contentGenerated: "IA",
    skillsPracticed: "Habilidades practicadas",
    generatedNotice:
      "Práctica de idioma creada por IA. No es capacitación ni política de trabajo real.",
    hazardBoundary:
      "No damos instrucciones médicas, químicas, de PPE o de procedimientos. Practicaremos cómo preguntar al profesional adecuado.",
    otherJobDescribeLabel: "Describe tu trabajo",
    otherJobDescribeHelp:
      "Describe tu trabajo para personalizar tus prácticas. Usa datos ficticios y no incluyas información confidencial de empleadores, clientes o pacientes.",
    otherJobDescribePlaceholder:
      "Ej: Limpio habitaciones en un hospital y necesito pedir permiso al paciente antes de entrar.",
    otherJobDescribeSaved: "Descripción guardada",
    otherJobDescribeOptional: "Opcional. Puedes editarla luego en Ajustes.",
    homePersonalizedForYouLabel: "Personalizado para tu trabajo",
    homePersonalizedCreateTitle: "Crear una práctica para: {desc}",
    homePersonalizedCreateSub:
      "Abriremos el generador con la información que ya nos diste. Podrás revisar antes de crear.",
    homeOtherNeedsDescTitle: "Cuéntanos más sobre tu trabajo",
    homeOtherNeedsDescSub:
      "Añade una descripción corta en Ajustes para recibir prácticas personalizadas.",
    homeOtherAddInSettings: "Añadir descripción en Ajustes",
    homeGeneralPracticeTitle: "Práctica general",
    homeGeneralPracticeSub:
      "Estas prácticas no están adaptadas a tu trabajo. Explora el catálogo general.",
    homeGeneralPracticeCta: "Ver práctica general",
    autoVoice: "Voz automática",
    autoVoiceOn: "Voz automática activada",
    autoVoiceOff: "Voz automática desactivada",
    tapToEnableAudio: "Toca para activar el audio",
    sessionMenu: "Menú de la práctica",
    pauseCta: "Pausar",
    savePauseTitle: "Guardar y pausar",
    savePauseHint: "Guardamos esta práctica sin terminar para retomarla después. Puedes borrarla en Ajustes cuando quieras.",
    pauseChooseOtherTitle: "Pausar y elegir otra práctica",
    pauseChooseOtherHint: "Guardamos esta práctica y abrimos el catálogo. Empezar otra no borra ésta.",
    endPracticeTitle: "Terminar práctica",
    endPracticeHint: "Cerramos esta práctica y podrás revisar cómo te fue.",
    backCta: "Volver",
    redoAnswerCta: "Decirlo de nuevo",
    redoAnswerHint: "Reemplaza tu última respuesta. La IA continuará desde tu nueva respuesta.",
    redoAnswerConfirmed: "Reemplaza tu última respuesta abajo.",
    discardTitle: "Descartar esta práctica",
    discardHint: "Borra esta práctica sin guardar nada.",
    discardConfirm: "¿Borrar esta práctica sin guardar?",
    cancelExit: "Seguir practicando",
    guestPauseNote: "Como invitado, esta práctica se guarda hasta 6 horas en este dispositivo. Crea una cuenta para conservarla.",
    recordingNotSaved: "La grabación no se guardó. Puedes escribir tu respuesta.",
    recordingTooShort: "No detectamos voz. Intenta de nuevo o escribe tu respuesta.",
    noSpeechDetected: "No escuché una respuesta. Toca el micrófono e inténtalo de nuevo.",
    practiceScopeForMyJob: "Para mi trabajo: {job}",
    practiceScopeForMyJobHint: "Solo mostramos prácticas relevantes a tu trabajo.",
    practiceScopeAllAreas: "Todas las áreas",
    practiceScopeAllAreasHint: "Estás explorando todo el catálogo. No cambiamos tu perfil.",
    practiceBrowseAll: "Explorar todas las áreas",
    practiceBackToMyJob: "Volver a mi trabajo",
    practiceNoCatalog: "Aún no tenemos prácticas del catálogo para tu área. Puedes usar tu práctica personalizada o explorar todas las áreas.",
    practiceOpenPersonalized: "Abrir mi práctica personalizada",
    feedbackChooseAnother: "Elegir otra práctica",
    feedbackCreateAnother: "Crear otra situación",
    briefingLevelLabel: "Nivel para este intento",
    briefingLevelHint: "Solo cambia este intento nuevo. Se conservan los hechos y roles originales; no cambia tu perfil.",
    translateBtn: "Traducir",
    translatePanelTitle: "Traducción al español",
    translateHide: "Ocultar traducción",
    translateAiNote: "Traducción asistida por IA. El original en inglés se mantiene.",
    translateSelectSentence: "Elige una oración",
    translateFullMessage: "Mensaje completo",
    translateError: "No se pudo traducir. Toca para reintentar.",
    translateLoading: "Traduciendo…",
    planTitle: "Mi plan de aprendizaje",
    planReviewLabel: "Repaso recomendado",
    planReviewCta: "Practicar de nuevo",
    planChallengeLabel: "Probar una versión más difícil",
    planChallengeCta: "Elegir el nivel",
    planNoHistoryHint: "Guarda tus prácticas para recibir sugerencias basadas en tu progreso.",
    progressTasksTitle: "Tareas y evidencia",
    progressTasksNote: "Basado solo en tus prácticas guardadas. La retroalimentación falta o insuficiente NO significa fracaso.",
    progressAttemptsSaved: "{n} guardadas",
    progressMissing: "Aún no demostrado",
    progressStatus_demonstrated: "Demostrado en la práctica",
    progressStatus_partially_demonstrated: "Parcialmente demostrado",
    progressStatus_practiced: "Practicado",
    progressStatus_not_enough_evidence: "Sin evidencia suficiente",
    practiceChoiceExplain: "Elige qué necesitas practicar. La IA interpreta a la otra persona.",
    createRoleLabel: "Tu rol",
    createRolePlaceholder: "Ej: Mesero, cajero, auxiliar de limpieza…",
    createRoleHint: "Opcional. Ayuda a la IA a interpretar bien a tu contraparte.",
    createPartnerLabel: "¿A quién debe interpretar la IA?",
    createExerciseNote: "Estos ajustes son solo para este ejercicio. No cambian tu perfil guardado.",
    yourRoleLabel: "Tu rol",
    yourRoleGeneric: "Empleado/a",
    aiRoleLabel: "La IA interpreta",
    createFromPractice: "Crear mi propia situación",
    createFromPracticeSub: "Describe una situación de tu trabajo y la IA la crea para ti.",
    resumePractice: "Reanudar",
    pausedList: "Prácticas pausadas",
    pausedListSub: "Retoma donde lo dejaste.",
    pausedTurns: "turno {n} de {max}",
    noPartialFeedback: "Necesitamos al menos una respuesta tuya para dar retroalimentación.",
    partialFeedback: "Retroalimentación parcial (práctica corta)",
    v1Version: "V1 en desarrollo",
    // Repositioning: landing + rehearsal-first framing (iteration 20)
    landingHeroTitle: "Prepárate para la conversación en el trabajo.",
    landingHeroBody: "Practica conversaciones reales en inglés con IA antes de tener que manejarlas con un cliente, compañero o supervisor.",
    landingPrimaryCta: "Empezar a practicar",
    landingSecondaryCta: "Ya tengo una cuenta",
    landingSection1Title: "¿Pasó algo difícil en el trabajo?",
    landingSection1Body: "Descríbelo en español o en inglés.",
    landingSection2Title: "Practica la conversación",
    landingSection2Body: "La IA interpreta al cliente, compañero, huésped o supervisor.",
    landingSection3Title: "Recibe orientación práctica",
    landingSection3Body: "Qué funcionó, qué decir de forma más natural, y prueba de nuevo.",
    landingSection4Title: "Prepárate mejor para la próxima",
    landingSection4Body: "Guarda frases útiles y ensaya situaciones parecidas.",
    landingSection5Title: "Creado para personas que usan inglés en el trabajo",
    landingSection5Body: "Restaurante, comercio, hotel, almacén, servicio al cliente, limpieza, apoyo en salud y otros roles de primera línea.",
    homeWorkRehearsalTitle: "Practica algo de tu trabajo",
    homeWorkRehearsalBody: "Describe una conversación que tuviste — o una que esperas tener.",
    homeWorkRehearsalCta: "Cuéntame qué pasó",
    onboardingRealSituationsNote: "También puedes practicar cualquier situación real que ocurra en tu trabajo. Solo cuéntanos qué pasó.",
    onboardingNeedsIntroTitle: "¿Qué tipos de conversaciones son más difíciles para ti en el trabajo?",
    briefingSituationEyebrow: "Tu situación",
    feedbackHowItWent: "Revisa tu práctica",
    feedbackReviewSubtitle: "Mira qué salió bien y qué puedes decir de forma más natural.",
    feedbackWhatWorked: "Qué funcionó",
    feedbackMoreNatural: "Comentarios sobre tu respuesta",
    feedbackWhyItWorks: "Por qué funciona",
    feedbackRehearseAgain: "Intentarlo de nuevo",
    goToReviewCta: "Revisar mi práctica",
    startRehearsalCta: "Comenzar práctica",
    createRehearseTitle: "Practicar una situación real del trabajo",
    planNext: "Tu próxima práctica",
    filterAll: "Todos",
    dangerZoneTitle: "Zona de seguridad",
    briefingEnOnly: "Solo inglés",
    searchPlaceholder: "Buscar una práctica…",
    missingLabel: "Qué faltó decir",
    missingHint: "No lo mencionaste en esta práctica.",
    suggestionLabel: "Puedes añadir…",
    progressLifecycleFinished: "Práctica concluida",
    progressLifecycleInProgress: "En progreso",
    feedbackAlternativesOptional: "Alternativas opcionales · así también suena natural",
    feedbackSectionNeutralNote: "Comentarios sobre tu respuesta",
    fbCat_error: "Corregir",
    fbCat_missing_objective: "Faltó decir",
    fbCat_acceptable: "Bien dicho",
    fbCat_optional_alternative: "Alternativa opcional",
    fbCatAffirmLabel: "Ya funciona así",
    fbCatAlternativeLabel: "También podrías decir",
    phraseCoachingCue: "Pista",
    phraseRevealCta: "Mostrar la frase en inglés",
    reviewCorrectAck: "¡Correcto! Dijiste la frase guardada exactamente.",
    // Password reset (ES)
    forgotPassword: "¿Olvidaste tu contraseña?",
    forgotPasswordTitle: "Recuperar contraseña",
    forgotPasswordSub: "Escribe tu correo y te enviaremos un enlace para crear una nueva contraseña.",
    sendResetLink: "Enviar enlace",
    resetLinkSent: "Si el correo está registrado, enviaremos un enlace de recuperación.",
    forgotPasswordAdminHint: "Si no lo recibes pronto, contacta a tu administrador para que te envíe un enlace de recuperación.",
    resetLinkPilotHint: "Piloto: como aún no hay envío por correo, tu enlace aparece aquí.",
    copyResetLink: "Copiar enlace",
    copied: "Enlace copiado",
    resetPasswordTitle: "Crear nueva contraseña",
    resetPasswordSub: "Elige una contraseña de al menos 8 caracteres.",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    passwordMismatch: "Las contraseñas no coinciden",
    resetSuccess: "Contraseña actualizada. Ya puedes iniciar sesión.",
    resetInvalidToken: "Enlace inválido o vencido. Solicita uno nuevo.",
    backToSignIn: "Volver a iniciar sesión",
    // Admin V1 (ES)
    adminEntryLabel: "Administración",
    adminEntryCardTitle: "Panel de administrador",
    adminEntryCardSub: "Panel, personas y escenarios",
    adminBackToApp: "Volver a ListoTalk",
    adminTabDashboard: "Panel",
    adminTabUsers: "Personas",
    adminTabScenarios: "Escenarios",
    adminUsersTotal: "Personas totales",
    adminUsersActive: "Activos (14 d)",
    adminCompletedTotal: "Prácticas completadas",
    adminCompletedToday: "Completadas hoy",
    adminByLevel: "Por nivel",
    adminByIndustry: "Por industria",
    adminPracticing: "Practicando",
    adminAvgPerUser: "Promedio por persona",
    adminEmailNotConfigured: "El envío por correo no está configurado. Los enlaces se muestran para copiar.",
    adminSearchUsers: "Buscar por correo…",
    adminColEmail: "Correo",
    adminColLevel: "Nivel",
    adminColIndustry: "Industria",
    adminColUiLang: "Idioma",
    adminColJoined: "Registro",
    adminColLastActive: "Última actividad",
    adminColStatus: "Estado",
    adminColActions: "Acciones",
    adminStatusActive: "Activo",
    adminStatusSuspended: "Suspendido",
    adminActionSuspend: "Suspender",
    adminActionReactivate: "Reactivar",
    adminActionResetPassword: "Restablecer contraseña",
    adminActionView: "Ver",
    adminNoUsers: "Sin resultados",
    adminResetLinkGenerated: "Enlace de recuperación creado. Compártelo con la persona.",
    adminConfirmSuspend: "¿Suspender esta cuenta? La persona no podrá iniciar sesión.",
    adminConfirmReactivate: "¿Reactivar esta cuenta?",
    // Admin V1 · bulk selection + delete
    adminBulkSelectAll: "Seleccionar todo",
    adminBulkClear: "Limpiar selección",
    adminBulkSelectedCount: "{n} seleccionado(s)",
    adminBulkDeleteBtn: "Eliminar seleccionados",
    adminBulkConfirmTitle: "Eliminar {n} cuenta(s) permanentemente",
    adminBulkConfirmBody: "Esta acción borra la cuenta y todos los datos asociados (prácticas, frases, situaciones personalizadas, enlaces de recuperación y reportes). No se puede deshacer.",
    adminBulkConfirmTypeLabel: "Escribe DELETE para confirmar:",
    adminBulkConfirmCancel: "Cancelar",
    adminBulkConfirmConfirm: "Eliminar definitivamente",
    adminBulkDeletedToast: "Se eliminaron {n} cuenta(s).",
    adminBulkSelfExcludedNote: "Tu propia cuenta no se puede eliminar.",
    adminFilterAll: "Todas",
    adminFilterIndustry: "Industria",
    adminFilterLevel: "Nivel",
    adminScenarioActive: "Activo",
    adminScenarioInactive: "Inactivo",
    // Wave 3 industry labels (ES)
    industryWarehouseLogistics: "Almacén / logística",
    industryHealthcareSupport: "Apoyo en salud (no clínico)",
    industryConstructionTrades: "Construcción / oficios",
    industryLandscaping: "Jardinería / áreas verdes",
    // Progression V1 (0/5 → 5/5 milestone). Uses the count of DISTINCT
    // finished CURATED practices for the learner's current job+level.
    progressCoreEyebrow: "Tu progreso",
    progressCoreCount: "{done} de {total} prácticas principales",
    progressCoreHint: "Nivel {level}. Solo cuentan prácticas del catálogo terminadas para tu trabajo.",
    progressMilestoneTitle: "¡Completaste las {total} prácticas principales de {level}!",
    progressMilestoneNote: "Es un logro de práctica, no una evaluación de tu inglés.",
    progressMilestoneAsk: "¿Qué quieres practicar ahora?",
    progressTryIntermediate: "Probar Intermedio",
    progressTryAdvanced: "Probar Avanzado",
    progressPracticeAgain: "Practicar de nuevo",
    progressPracticeVariation: "Practicar una variación",
    progressCreateOwn: "Crear mi propia situación",
    progressAdvancedExplore: "Explorar más prácticas",
    // Remix / practice-a-variation mode surfaced on Practice + Briefing.
    practiceRemixTitle: "Practicar una variación",
    practiceRemixSubtitle: "Elige una práctica que ya terminaste. La situación es la misma, pero el diálogo se sentirá un poco distinto.",
    practiceRemixEmpty: "Todavía no completaste ninguna práctica de este nivel para tu trabajo.",
    practiceRemixBackToCatalog: "Ver todas las prácticas",
    briefingRemixBadge: "Variación",
    briefingRemixHint: "Es la misma práctica que ya completaste. Los hechos y objetivos no cambian; el diálogo puede variar un poco.",
    briefingYouAre: "Tú eres:",
    briefingAiRole: "IA:",
    briefingLearnerRoleFallback: "empleado(a) en el trabajo",
    briefingInfoYouKnow: "Información que sabes",
  },
  en: {
    brand: "ListoTalk AI",
    subbrand: "Work English rehearsal",
    langToggle: "ES",
    langToggleAria: "Switch language between Spanish and English",
    signIn: "Sign in",
    signUp: "Create account",
    signOut: "Sign out",
    email: "Email",
    password: "Password",
    passwordHint: "At least 8 characters.",
    or: "or",
    tryPractice: "Try a practice",
    tryFree: "Try a free practice",
    heroTitle: "Practice the English you use at work",
    heroSub: "Short conversations with clear Spanish coaching. Fictional scenarios only.",
    valueRealScenarios: "Real customer service scenarios",
    valueVoice: "Voice or text: your choice",
    valueSpanishCoach: "Clear, low-pressure feedback",
    pilotBadge: "Research pilot · Not for sale",
    disclaimer: "AI practice guidance. Not a certified language assessment.",
    accountSection: "Your account",
    dashboardTitle: "Choose a practice",
    dashboardSub: "Five short workplace situations to try today.",
    continue: "Continue",
    startPractice: "Start practice",
    briefingTitle: "Before you start",
    goal: "Goal",
    facts: "Fictional facts you share with the customer",
    checkpoints: "Task checkpoints",
    phrases: "Useful English phrases",
    startConvo: "Start conversation",
    conversation: "Conversation",
    speakNormal: "Normal speed",
    speakSlow: "Slower",
    replay: "Replay audio",
    hint: "Ask for help",
    hintOff: "Close help",
    hintLoading: "Loading help…",
    hintCoachingLabel: "Hint",
    hintStarterCta: "You can start with…",
    hintExampleCta: "See example",
    hintFillDraftCta: "Use as draft",
    hintGuidedNote: "This example counts as guided practice, not independent evidence.",
    micTap: "Tap to speak",
    stop: "Stop",
    listen: "Listen",
    submit: "Send",
    typeAnswer: "Type my answer",
    switchToVoice: "Switch to voice",
    switchToText: "Switch to text",
    finish: "Finish and review my practice",
    processing: "Processing…",
    recording: "Recording…",
    transcribing: "Transcribing…",
    responding: "Customer replying…",
    reviewTranscript: "Review before sending",
    micDenied: "Microphone denied. You can type your answer.",
    micUnsupported: "Recording not supported here. Use text mode.",
    aiUnavailable: "AI service unavailable. Try again later.",
    dailyLimit: "You reached the daily practice limit. Try again tomorrow.",
    guestNote: "You are practicing as a guest. Create an account to save progress.",
    feedbackTitle: "Feedback",
    doneWell: "Done well",
    improvements: "To improve",
    modelResponse: "Model response",
    checkpointsList: "Task checkpoints",
    original: "Your phrase",
    improved: "Improved phrase",
    explanation: "Explanation",
    retry: "Try this practice again",
    backHome: "Back to home",
    progressTitle: "My progress",
    noHistory: "No saved practices yet.",
    deletePractice: "Delete",
    confirmDelete: "Delete this practice?",
    deleteAccount: "Delete my account and all my data",
    confirmDeleteAccount: "This will erase your account and all your data. Continue?",
    onboardingTitle: "A couple of details before we start",
    onboardingLevel: "Your English level",
    onboardingContext: "What area do you work in? (optional)",
    levelBasic: "Basic",
    levelBasicHint: "Simple phrases and frequent support",
    levelInter: "Intermediate",
    levelInterHint: "Continuous flow, nuanced coaching",
    saveContinue: "Save and continue",
    skip: "Skip",
    workContextCallCenter: "Call center",
    workContextHospitality: "Hospitality",
    workContextRestaurant: "Restaurant",
    workContextRetail: "Retail",
    workContextTravel: "Travel & airport",
    workContextOther: "Other",
    pilotConsent:
      "Use fictional data only. Do not share real customer or employer information.",
    unsupportedNotice: "Voice recording is not available on this device.",
    completed: "Completed",
    inProgress: "In progress",
    date: "Date",
    scenario: "Scenario",
    close: "Close",
    tabPractice: "Practices",
    tabProgress: "My progress",
    guestBanner: "Guest mode",
    saved: "Saved",
    ttsUnavailable: "Audio not available right now.",
    finishConfirm: "Finish this practice and review it?",
    yes: "Yes",
    no: "No",
    errorGeneric: "Something went wrong. Try again.",
    authEmailTaken: "Email already registered.",
    authInvalidCredentials: "Invalid email or password.",
    feedbackLoading: "Preparing your review…",
    feedbackLoadErrorTitle: "We couldn't load your review",
    feedbackLoadRetry: "Retry",
    modeVoice: "Voice",
    modeText: "Text",
    aiCustomer: "Customer (AI)",
    youEmployee: "You (employee)",
    finishedBadge: "Practice complete",
    unsavedTitle: "What do you want to do with this practice?",
    unsavedBody: "You haven't saved it to My progress yet.",
    unsavedSaveCta: "Save to My progress",
    unsavedReviewCta: "Review my practice",
    unsavedExitCta: "Exit without saving",
    invalidFeedback: "We could not generate structured feedback. Try practicing again.",
    speakingTip: "Speak English to the customer. Remember this is a fictional practice.",
    accountEmail: "Email",
    createAccount: "Create a new account",
    haveAccount: "Already have an account? Sign in",
    noAccount: "New here? Create an account",
    formError: "Please check the fields and try again.",
    finishConfirmYes: "Yes, finish",
    retryThisReply: "Practice this reply again",
    retryPlaceholder: "Type your improved answer in English",
    retrySubmit: "Send retry",
    retryOriginal: "Original answer",
    retryNew: "Your new answer",
    retryCustomerReply: "New customer reply",
    coachNote: "Coach note",
    saveToHistory: "Save to my history",
    saveOff: "Saved. Tap to remove from history.",
    saveNotice: "We only keep practices you choose to save. You can delete them anytime.",
    progressSummary: "Summary",
    progressCompleted: "Objectives achieved",
    progressInProgress: "In progress",
    progressSaved: "Saved",
    recentPhrases: "Recent helpful phrases",
    checkpointsImproved: "Task checkpoints improved",
    notEnoughPractice: "Not enough saved practice yet to show improvement.",
    retryLimit: "Retry limit reached for this practice.",
    retryHelp: "This retries only this reply. It does not change your practice result.",
    // V1 additions
    tabHome: "Home",
    tabPhrases: "My Phrases",
    tabSettings: "Settings",
    homeGreeting: "Hi",
    homeContinue: "Continue your practice",
    homeRecommended: "Recommended for you",
    homeCreate: "Create my own situation",
    homeCreateSub: "Describe a real situation from your job and we will generate a practice.",
    homePlanNote: "Recommendations based on your profile and saved practices.",
    workProfile: "My work",
    workProfileSub: "You can change this anytime in Settings.",
    industry: "Industry or setting",
    roleLabel: "Job title or role",
    tasks: "Frequent tasks",
    partners: "Who you talk with",
    needsHeader: "Communication needs",
    timePref: "Session length",
    languagePref: "Preferred language",
    levelAdvanced: "Advanced",
    levelAdvancedHint: "Rich phrasing, real conversation",
    partnerCustomer: "Customers",
    partnerCoworker: "Coworkers",
    partnerSupervisor: "Supervisor",
    partnerPatient: "Patients/visitors",
    needAskClar: "Ask for clarification",
    needUnderstand: "Understand a spoken request",
    needExplain: "Explain an issue",
    needAskPerm: "Ask permission politely",
    needReportStatus: "Report status",
    needAskHelp: "Request help or supplies",
    needDisagree: "Handle disagreement",
    needPhone: "Phone conversations",
    needTalkSup: "Talk with a supervisor",
    industryRetail: "Retail / cashier",
    industryHospitalClean: "Cleaning / Housekeeping",
    industryHospitality: "Hospitality",
    industryRestaurant: "Restaurant",
    industryCallCenter: "Call center",
    industryTravel: "Travel / airport",
    industryOffice: "Office",
    industryOther: "Other / Describe my job",
    createSituationTitle: "Create my own situation",
    createSituationHint:
      "Briefly describe what happens. Use fictional details: never share real names, records, or confidential employer/customer information.",
    createSituationPlaceholder:
      "Ex: I clean rooms and need to ask permission to enter a patient's room.",
    generate: "Generate practice",
    regenerate: "Regenerate",
    startNow: "Start now",
    aiCreatedLabel: "AI-created — not approved occupational training",
    curatedLabel: "Reviewed content",
    reportContent: "Report content",
    reportPlaceholder: "Tell us what's wrong with this practice…",
    reportSubmit: "Send report",
    reportSent: "Report sent. Thank you.",
    phrasesTitle: "My saved phrases",
    phrasesEmpty: "No saved phrases yet. Save them from your feedback screen.",
    savePhraseCta: "Save this phrase",
    savedPhrase: "Phrase saved",
    reviewMode: "Review mode",
    reviewCta: "Review",
    reviewPromptEs: "Spanish prompt",
    revealAnswer: "Reveal English answer",
    typeYourAnswer: "Type your English answer",
    submitReview: "Submit",
    settingsTitle: "Settings",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    passwordChanged: "Password changed.",
    exportMyData: "Export my data",
    exportedNote: "A JSON file with your data has been downloaded.",
    helpTitle: "Help",
    faqPractice: "How to practice",
    faqAI: "About AI feedback",
    faqPronunciation: "Pronunciation",
    faqPrivacy: "Privacy and data",
    faqAIText:
      "Feedback is AI-generated and can be wrong. This is not a certified language assessment.",
    faqPronText:
      "This pilot does NOT rate accent or pronunciation from audio. It focuses on understandable communication and professional tone.",
    faqPrivacyText:
      "We only save practices you choose to save. Audio is processed temporarily and deleted after transcription. You can export or delete your data in Settings.",
    accessTitle: "Pilot access",
    accessBody:
      "This is a research pilot. Proposed price: $15/month, not for sale. No checkout and no charges.",
    accessRemaining: "Practices remaining today",
    accessCustomGenLeft: "Custom generations remaining today",
    installHome: "Add to Home Screen",
    installHint: "On your phone, open the browser menu and select 'Add to Home Screen' or 'Install'.",
    contentSource: "Source",
    contentCurated: "Reviewed",
    contentGenerated: "AI",
    skillsPracticed: "Skills practiced",
    generatedNotice:
      "AI-created language practice. Not employer-approved training or policy.",
    hazardBoundary:
      "We don't provide medical, chemical, PPE or procedure instructions. We practice how to ask the right professional.",
    otherJobDescribeLabel: "Describe your job",
    otherJobDescribeHelp:
      "Describe your job so we can personalize your practice. Use fictional details — do not include confidential employer, customer or patient information.",
    otherJobDescribePlaceholder:
      "Ex: I clean rooms at a hospital and I need to ask permission before entering a patient room.",
    otherJobDescribeSaved: "Description saved",
    otherJobDescribeOptional: "Optional. You can edit it later in Settings.",
    homePersonalizedForYouLabel: "Personalized for your job",
    homePersonalizedCreateTitle: "Create a practice for: {desc}",
    homePersonalizedCreateSub:
      "We'll open the generator with the details you already shared. You can review before creating.",
    homeOtherNeedsDescTitle: "Tell us more about your job",
    homeOtherNeedsDescSub:
      "Add a short description in Settings to receive personalized practices.",
    homeOtherAddInSettings: "Add description in Settings",
    homeGeneralPracticeTitle: "General practice",
    homeGeneralPracticeSub:
      "These practices are not tailored to your job. Explore the general catalog.",
    homeGeneralPracticeCta: "See general practice",
    autoVoice: "Automatic voice",
    autoVoiceOn: "Automatic voice on",
    autoVoiceOff: "Automatic voice off",
    tapToEnableAudio: "Tap to enable audio",
    sessionMenu: "Practice menu",
    pauseCta: "Pause",
    savePauseTitle: "Save and pause",
    savePauseHint: "We save this unfinished practice so you can pick it up later. You can delete it in Settings anytime.",
    pauseChooseOtherTitle: "Pause and choose another",
    pauseChooseOtherHint: "We save this practice and open the catalog. Starting another one does not delete this one.",
    endPracticeTitle: "End practice",
    endPracticeHint: "We close this practice so you can review how it went.",
    backCta: "Back",
    redoAnswerCta: "Redo my answer",
    redoAnswerHint: "Replace your last answer. The AI will continue from your new one.",
    redoAnswerConfirmed: "Edit or re-speak your last answer below.",
    discardTitle: "Discard this practice",
    discardHint: "Delete this practice without saving anything.",
    discardConfirm: "Delete this practice without saving?",
    cancelExit: "Keep practicing",
    guestPauseNote: "As a guest, this practice is saved for up to 6 hours on this device. Create an account to keep it.",
    recordingNotSaved: "The recording was not saved. You can type your reply.",
    recordingTooShort: "We didn't detect any speech. Try again or type your reply.",
    noSpeechDetected: "I didn't hear an answer. Tap the microphone and try again.",
    practiceScopeForMyJob: "For my job: {job}",
    practiceScopeForMyJobHint: "Showing only practices relevant to your job.",
    practiceScopeAllAreas: "All work areas",
    practiceScopeAllAreasHint: "You're browsing the full catalog. We don't change your profile.",
    practiceBrowseAll: "Browse all work areas",
    practiceBackToMyJob: "Back to my job",
    practiceNoCatalog: "We don't have catalog practices for your area yet. Use your personalized practice or browse all work areas.",
    practiceOpenPersonalized: "Open my personalized practice",
    feedbackChooseAnother: "Choose another practice",
    feedbackCreateAnother: "Create another situation",
    briefingLevelLabel: "Level for this attempt",
    briefingLevelHint: "Applies to this new attempt only. Original facts and roles are preserved; your profile does not change.",
    translateBtn: "Translate",
    translatePanelTitle: "Traducción al español",
    translateHide: "Hide translation",
    translateAiNote: "AI-assisted translation. The original English stays visible.",
    translateSelectSentence: "Pick a sentence",
    translateFullMessage: "Full message",
    translateError: "Could not translate. Tap to try again.",
    translateLoading: "Translating…",
    planTitle: "My Learning Plan",
    planReviewLabel: "Recommended for review",
    planReviewCta: "Practice again",
    planChallengeLabel: "Try a harder version",
    planChallengeCta: "Pick a level",
    planNoHistoryHint: "Save your practices to receive suggestions based on your progress.",
    progressTasksTitle: "Tasks and evidence",
    progressTasksNote: "Based only on your saved practices. Missing or insufficient feedback does NOT mean failure.",
    progressAttemptsSaved: "{n} saved",
    progressMissing: "Not demonstrated yet",
    progressStatus_demonstrated: "Demonstrated in practice",
    progressStatus_partially_demonstrated: "Partially demonstrated",
    progressStatus_practiced: "Practiced",
    progressStatus_not_enough_evidence: "Not enough evidence",
    practiceChoiceExplain: "Choose what you need to practice. AI plays the other person.",
    createRoleLabel: "Your role",
    createRolePlaceholder: "Ex: Server, cashier, hospital housekeeper…",
    createRoleHint: "Optional. Helps the AI play the other person accurately.",
    createPartnerLabel: "Who should the AI play?",
    createExerciseNote: "These settings apply to this exercise only. They do not change your saved profile.",
    yourRoleLabel: "Your role",
    yourRoleGeneric: "Employee",
    aiRoleLabel: "AI plays",
    createFromPractice: "Create my own situation",
    createFromPracticeSub: "Describe a situation from your job and the AI creates it for you.",
    resumePractice: "Resume",
    pausedList: "Paused practices",
    pausedListSub: "Pick up where you left off.",
    pausedTurns: "turn {n} of {max}",
    noPartialFeedback: "We need at least one reply from you to give feedback.",
    partialFeedback: "Partial feedback (short practice)",
    v1Version: "V1 in progress",
    // Repositioning: landing + rehearsal-first framing (iteration 20)
    landingHeroTitle: "Be ready for the conversation at work.",
    landingHeroBody: "Practice real English conversations with AI before you have to handle them with a customer, coworker, or supervisor.",
    landingPrimaryCta: "Start practicing",
    landingSecondaryCta: "I already have an account",
    landingSection1Title: "Something difficult happen at work?",
    landingSection1Body: "Describe it in Spanish or English.",
    landingSection2Title: "Practice the conversation",
    landingSection2Body: "AI plays the customer, coworker, guest or supervisor.",
    landingSection3Title: "Get practical coaching",
    landingSection3Body: "What worked, what to say more naturally, and try again.",
    landingSection4Title: "Be better prepared next time",
    landingSection4Body: "Save useful phrases and rehearse similar situations.",
    landingSection5Title: "Built for people who use English on the job",
    landingSection5Body: "Restaurant, retail, hotel, warehouse, customer service, housekeeping, healthcare support, and other frontline roles.",
    homeWorkRehearsalTitle: "Practice something from work",
    homeWorkRehearsalBody: "Describe a conversation you had — or one you expect to have.",
    homeWorkRehearsalCta: "Tell me what happened",
    onboardingRealSituationsNote: "You can also rehearse any real situation that happens at your job. Just tell us what happened.",
    onboardingNeedsIntroTitle: "What kinds of conversations are hardest for you at work?",
    briefingSituationEyebrow: "Your situation",
    feedbackHowItWent: "Review your practice",
    feedbackReviewSubtitle: "See what went well and what you can say more naturally.",
    feedbackWhatWorked: "What worked",
    feedbackMoreNatural: "Feedback on your response",
    feedbackWhyItWorks: "Why it works",
    feedbackRehearseAgain: "Try it again",
    goToReviewCta: "Review my practice",
    startRehearsalCta: "Start rehearsal",
    createRehearseTitle: "Rehearse a real work situation",
    planNext: "Your next practice",
    filterAll: "All",
    dangerZoneTitle: "Danger zone",
    briefingEnOnly: "English only",
    searchPlaceholder: "Search a practice…",
    missingLabel: "What was missing",
    missingHint: "You didn't mention this in this practice.",
    suggestionLabel: "You can add…",
    progressLifecycleFinished: "Practice complete",
    progressLifecycleInProgress: "In progress",
    feedbackAlternativesOptional: "Optional alternatives · these also sound natural",
    feedbackSectionNeutralNote: "Feedback on your response",
    fbCat_error: "Fix this",
    fbCat_missing_objective: "Missing",
    fbCat_acceptable: "Already good",
    fbCat_optional_alternative: "Optional alternative",
    fbCatAffirmLabel: "This already works",
    fbCatAlternativeLabel: "You could also say",
    phraseCoachingCue: "Cue",
    phraseRevealCta: "Reveal the English phrase",
    reviewCorrectAck: "Correct! You said the saved phrase exactly.",
    // Password reset (EN)
    forgotPassword: "Forgot your password?",
    forgotPasswordTitle: "Reset password",
    forgotPasswordSub: "Enter your email and we'll send you a link to set a new password.",
    sendResetLink: "Send link",
    resetLinkSent: "If that email is registered, we'll send a reset link.",
    forgotPasswordAdminHint: "If you don't receive it soon, contact your administrator to have a reset link generated for you.",
    resetLinkPilotHint: "Pilot: email delivery isn't configured yet, so your link is shown here.",
    copyResetLink: "Copy link",
    copied: "Link copied",
    resetPasswordTitle: "Set new password",
    resetPasswordSub: "Choose a password with at least 8 characters.",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match",
    resetSuccess: "Password updated. You can sign in now.",
    resetInvalidToken: "Invalid or expired link. Please request a new one.",
    backToSignIn: "Back to sign in",
    // Admin V1 (EN)
    adminEntryLabel: "Admin",
    adminEntryCardTitle: "Admin panel",
    adminEntryCardSub: "Dashboard, users, and scenarios",
    adminBackToApp: "Back to ListoTalk",
    adminTabDashboard: "Dashboard",
    adminTabUsers: "Users",
    adminTabScenarios: "Scenarios",
    adminUsersTotal: "Total users",
    adminUsersActive: "Active (14 d)",
    adminCompletedTotal: "Completed practices",
    adminCompletedToday: "Completed today",
    adminByLevel: "By level",
    adminByIndustry: "By industry",
    adminPracticing: "Practicing",
    adminAvgPerUser: "Avg per practicing user",
    adminEmailNotConfigured: "Email delivery is not configured. Reset links are shown for copy.",
    adminSearchUsers: "Search by email…",
    adminColEmail: "Email",
    adminColLevel: "Level",
    adminColIndustry: "Industry",
    adminColUiLang: "Language",
    adminColJoined: "Joined",
    adminColLastActive: "Last active",
    adminColStatus: "Status",
    adminColActions: "Actions",
    adminStatusActive: "Active",
    adminStatusSuspended: "Suspended",
    adminActionSuspend: "Suspend",
    adminActionReactivate: "Reactivate",
    adminActionResetPassword: "Reset password",
    adminActionView: "View",
    adminNoUsers: "No results",
    adminResetLinkGenerated: "Reset link created. Share it with the user.",
    adminConfirmSuspend: "Suspend this account? The user won't be able to sign in.",
    adminConfirmReactivate: "Reactivate this account?",
    // Admin V1 · bulk selection + delete
    adminBulkSelectAll: "Select all",
    adminBulkClear: "Clear selection",
    adminBulkSelectedCount: "{n} selected",
    adminBulkDeleteBtn: "Delete selected",
    adminBulkConfirmTitle: "Permanently delete {n} account(s)",
    adminBulkConfirmBody: "This deletes the account and all associated data (practices, phrases, custom situations, reset links, and reported issues). This cannot be undone.",
    adminBulkConfirmTypeLabel: "Type DELETE to confirm:",
    adminBulkConfirmCancel: "Cancel",
    adminBulkConfirmConfirm: "Delete permanently",
    adminBulkDeletedToast: "Deleted {n} account(s).",
    adminBulkSelfExcludedNote: "Your own account can't be deleted.",
    adminFilterAll: "All",
    adminFilterIndustry: "Industry",
    adminFilterLevel: "Level",
    adminScenarioActive: "Active",
    adminScenarioInactive: "Inactive",
    // Wave 3 industry labels (EN)
    industryWarehouseLogistics: "Warehouse / logistics",
    industryHealthcareSupport: "Healthcare support (nonclinical)",
    industryConstructionTrades: "Construction / trades",
    industryLandscaping: "Landscaping / grounds",
    // Progression V1
    progressCoreEyebrow: "Your progress",
    progressCoreCount: "{done} of {total} core practices",
    progressCoreHint: "{level} level. Only finished catalog practices from your job area count.",
    progressMilestoneTitle: "You finished all {total} core {level} practices!",
    progressMilestoneNote: "This is a practice milestone, not an English proficiency score.",
    progressMilestoneAsk: "What do you want to practice now?",
    progressTryIntermediate: "Try Intermediate",
    progressTryAdvanced: "Try Advanced",
    progressPracticeAgain: "Practice again",
    progressPracticeVariation: "Practice a variation",
    progressCreateOwn: "Create my own situation",
    progressAdvancedExplore: "Explore more practices",
    // Remix / practice-a-variation
    practiceRemixTitle: "Practice a variation",
    practiceRemixSubtitle: "Pick a practice you already finished. The situation is the same, but the conversation will feel a bit different.",
    practiceRemixEmpty: "You haven't finished any practices at this level for your job yet.",
    practiceRemixBackToCatalog: "See all practices",
    briefingRemixBadge: "Variation",
    briefingRemixHint: "Same practice you already finished. Facts and objectives don't change; the dialogue may vary a bit.",
    briefingYouAre: "You are:",
    briefingAiRole: "AI:",
    briefingLearnerRoleFallback: "an employee at work",
    briefingInfoYouKnow: "Information you know",
  },
};

export const t = (lang, key) => {
  const table = dict[lang] || dict.es;
  return table[key] ?? dict.es[key] ?? key;
};
